import { memo } from 'react';
import PropTypes from 'prop-types';

import { PipelineAlt as PipelineIcon } from 'basic-components/icons';

import './NodeCircle.scss';

let IconEl = PipelineIcon
const DiagramElementIcons = {
  Pipeline: PipelineIcon
}

// Core
const NodeCircle = ({ diagramNodeType }) => {
  if(DiagramElementIcons[diagramNodeType]){
    IconEl = DiagramElementIcons[diagramNodeType]
  }
  return (
    <div className="insight-node-widget__node-circle">
      <div className="insight-node-widget__node-circle__circle">
        <div className="insight-node-widget__node-circle__circle__icon">
          <IconEl
              height={24}
              width={24}
          />
        </div>
      </div>
    </div>
  )
}

NodeCircle.propTypes = {
  diagramNodeType: PropTypes.string.isRequired,
}

export default memo(NodeCircle);